var WsRadioColors = /* @__PURE__ */ ((WsRadioColors2) => {
  WsRadioColors2["BLUE"] = "blue";
  WsRadioColors2["GREEN"] = "green";
  return WsRadioColors2;
})(WsRadioColors || {});
const WsRadioColors$1 = WsRadioColors;
export {
  WsRadioColors,
  WsRadioColors$1 as default
};
//# sourceMappingURL=WsRadio.enum.es.js.map
